import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudService, HttpCancelService, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, NO_DATA_FOUND_MESSAGE, RxjsService } from '@app/shared';
import { EventMgntModuleApiSuffixModels } from '@modules/event-management/shared/enums/configurations.enum';
import { loggedInUserData } from '@modules/others';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-response-instructions-view-details',
  templateUrl: './response-instructions-view-details.component.html',
  styleUrls: ['./response-instructions-view-details.component.scss']
})
export class ResponseInstructionsViewDetailsComponent implements OnInit {
  @Input() occurrenceBookId = '';
  @Input() customerAddressId = '';
  @Input() customerId = '';
  @Input() config: any;
  @Input() customerName = '';
  @Input() customerAddress = '';
  loggedInUserData: LoggedInUserModel;
  responseInstrcutionDetails;
  NO_DATA_FOUND_MESSAGE = NO_DATA_FOUND_MESSAGE;

  constructor(private crudService: CrudService,
    private router: Router,
    private store: Store<AppState>,
    private rxjsService: RxjsService, private httpCancelService: HttpCancelService) {
    this.rxjsService.setDialogOpenProperty(true);
    this.rxjsService.setPopupLoaderProperty(true);
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.getResponseInstructionDetails();
  }

  combineLatestNgrxStoreData() {
    combineLatest([this.store.select(loggedInUserData)]).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
    });
  }

  getResponseInstructionDetails() {
    this.crudService.get(ModulesBasedApiSuffix.EVENT_MANAGEMENT, EventMgntModuleApiSuffixModels.RESPONSE_INSTRUCTION, this.occurrenceBookId ? this.occurrenceBookId : this.config?.data?.occurrenceBookId, false, null)
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200 && response.resources) {
          //         response.resources= {
          //   "domesticWorkers": [{employeeName:"new","workerTypeName":"new","isSleepIn":"new","days":"new"}],
          //   "securityOfficers": [
          //     {
          //       "groupNumber": 4,
          //       "securityServiceProviderName": "Divya",
          //       "type": "Armed",
          //       "noOfSecurityOfficers": 1,
          //       "workSchedule": "",
          //       "siteNumber": "",
          //       "controlRoomPhoneNo": "+27 123123233",
          //       "identityNo": ""
          //     }
          //   ],
          //   "accessPremisesDigipadLockbox":[{groupNumber:13,accessPremisesType:"new",accessCode:"new",rowNumber:"new",description:"new",GateName:"new"}],
          //   "accessPremisesPadlockBarrelLock": [
          //       {
          //       "groupNumber": 13,
          //       "accessPremisesType": "Premise Number Visible",
          //       "isOnGate": "",
          //       "doorGate": "",
          //       "description": ""
          //     },
          //     {
          //       "groupNumber": 13,
          //       "accessPremisesType": "Premise Number Visible",
          //       "isOnGate": "",
          //       "doorGate": "",
          //       "description": ""
          //     }],
          //   "accessPremiseDigipadLockbox": [{
          //       "groupNumber": 13,
          //       "accessPremisesType": "Premise Number Visible",
          //       "accessCode": "",
          //       "rowNumber": "",
          //       "description": "",
          //       "GateName": ""
          //     }],
          //   "accessPremisesOthers": [{accessPremisesType:"new","description":"new"}],
          //   "hazards": [
          //     {
          //       "groupNumber": 14,
          //       "hazards": "Premise Number Visible",
          //       "details": ""
          //     },
          //     {
          //       "groupNumber": 15,
          //       "hazards": "Swimming Pool",
          //       "details": "Swimming Pool"
          //     }
          //   ],
          //   "medicalInstructions": [
          //     {
          //       "medicalCondition": "No",
          //       "medications": null,
          //       "allergies": null
          //     }
          //   ],
          //   "siteInstructionForAROfficer": [
          //     {
          //       "description": "Site Instruction AR Officer"
          //     }
          //   ],
          //   "hazardRiskDescription": [
          //     {
          //       "description": "Notable Risks"
          //     }
          //   ]
          // }
          this.responseInstrcutionDetails = response.resources;
          setTimeout(() => {
            this.rxjsService.setGlobalLoaderProperty(false);
            this.rxjsService.setPopupLoaderProperty(false);
          }, 1000);
        }
      });
  }

  onSubmitAcknowledgement() {
    let formValue = { occurrenceBookId: this.occurrenceBookId, acknowledgedBy: this.loggedInUserData?.userId };
    this.httpCancelService.cancelPendingRequestsOnFormSubmission();
    this.crudService.create(ModulesBasedApiSuffix.EVENT_MANAGEMENT, EventMgntModuleApiSuffixModels.OCCURRENCE_BOOK_ACKNOWLEDGEMENT_RESPONSE_INSTRUCTION, formValue)
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          this.router.navigate(["/event-management/stack-operator/call-workflow-list/list"], { queryParams: { id: this.occurrenceBookId, customerId: this.customerId, customerAddressId: this.customerAddressId, customerName: this.customerName, customerAddress: this.customerAddress, tab: 2 } });
        }
        this.rxjsService.setGlobalLoaderProperty(false);
        this.rxjsService.setPopupLoaderProperty(false);
      });
  }

  ngOnDestroy() {
    this.rxjsService.setDialogOpenProperty(false);
  }
}
